<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_vi"></a>To the memory of Maurice Heine, who freed Sade from the prison wherein he was held captive for over a century after his death, and to Gilbert Lely, who has unselfishly devoted himself to this same task of liberation and restitution.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?8aa22a82